import { IObject } from "@entities/api/object";
import { IUpdateObject } from "@entities/object";
import { uuidRegex } from "@shared/utils";
import { FormType } from "../../../types/form-type";

/*
 * Случаи
 * 1. Документ новый {key: string, ...metaData}
 * 2. Документ обновляется {key: string, ...metaData}
 * 3. Документ остается {key: null}
 * 4. Документ удаляется null
 * */
export function getDocumentationExaminations(
  data: FormType,
  orig: IObject,
):
  | [IUpdateObject["documentationExaminations"], File[] | undefined]
  | undefined {
  if (!data.examinations?.required) {
    return [
      // @ts-expect-error optionals
      orig.documentationExaminations.map((p) => ({
        documentationExaminationId: p.documentationExaminationId,
      })),
      undefined,
    ];
  }

  if (data.examinations.documentationExaminations) {
    const examinationsFiles = [] as { file?: File | null; uid: string }[];

    const documentationExaminations =
      data.examinations.documentationExaminations.map((p) => {
        if (p.file?.id && !uuidRegex.test(p.file.id)) {
          examinationsFiles.push({
            uid: p.file.id,
            file: p.file.file,
          });
        }

        let file = null;
        if (uuidRegex.test(p.file?.id ?? "")) {
          file = {
            key: null,
          };
        } else if (p.file?.id) {
          file = {
            key: p.file?.id,
            fileName: p.file?.file?.name,
            fileType: p.file?.file?.type,
            fileContentLength: p.file?.file?.size,
          };
        }

        return {
          documentationExaminationId: p.documentationExaminationId ?? null,
          number: p.number,
          issued: p.issued,
          date: p.date.toISOString(),
          examinationFile: {
            file,
            // WAIT: на время убираем подписи
            signature: null,
          },
        };
      });

    if (data.deletedExaminations && data.deletedExaminations.size > 0) {
      const idsToDelete = Array.from(data.deletedExaminations);
      idsToDelete.forEach((id) => {
        const stillPresent = data.examinations?.documentationExaminations?.some(
          (p) => p.documentationExaminationId === id,
        );
        if (!stillPresent) {
          // @ts-expect-error partial deletions
          documentationExaminations.push({ documentationExaminationId: id });
        }
      });
    }

    // @ts-expect-error переделать после добавления signatures
    return [documentationExaminations, examinationsFiles] as [
      typeof documentationExaminations,
      typeof examinationsFiles,
    ];
  }
}
